import React, { useEffect } from "react";
import "./modalSolicitudServicios.scss";
import { useStaticQuery, graphql, navigate } from "gatsby";
import { BLOCKS } from "@contentful/rich-text-types";
import rawToReact from "../../../utils/rawToReact";

interface ModalProps extends React.ComponentProps<"div"> {
    children?: React.ReactNode
    showModal: boolean
    onClose: () => void
}

const ModalSolicitudServicios: React.FC<ModalProps> = (props: ModalProps) => {
    const { children, showModal, ...rest} = props
    const compClass = "cfmui-modal"

    useEffect(() => {
        document.body.style.overflow = showModal ? "scroll" : "unset"
    }, [props.showModal])

    const modalData = useStaticQuery(graphql`
        query MODALSOLICITUDESSERVICIOS {
            contentfulContactenos(contentful_id: {eq: "5a08pDWdjWRDfEscxtoesP"}) {
            imagenesEmpleo {
                file {
                url
                }
            }
            tituloPrincipal
            redireccionBoton
            redireccionBotonOpcional
            descripcion {
                raw
            }
            descripcionFormulario {
                raw
            }
            }
        }
    `);

    const {imagenesEmpleo, 
        tituloPrincipal, 
        redireccionBoton, 
        redireccionBotonOpcional,
        descripcion,
        descripcionFormulario} = modalData.contentfulContactenos

    // Funcion para renderizar contenido de texto de tipo json provenientes de contentful
    const contentfulRenderOptions = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, child) => {
                if (child[0].props.children[1].split(" ")[2] === 'persona'){
                    return <p className={'gtm_solicitar_servicios_personas_modulo'}> {child} </p>
                }else{
                    return <p className={'gtm_solicitar_servicios_empresas_modulo'}> {child} </p>
                }
            },
        },
        renderText: (text) =>
        text.split("\n").flatMap((txt, i) => [i > 0 && <br />, txt]),
    };

    const attributes = {
        ...rest,
        className: `${rest.className || ""} ${compClass}`.trim(),
    };

    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname : ''

    return (
        <div {...attributes}>
            <div className="modal-servicios__box">
                <button
                    type="button"
                    className="close-button"
                    onClick={rest.onClose}
                />
                <div className="modal-servicios__content">
                    <h2 className="modal-servicios__title">
                        {tituloPrincipal}
                    </h2>
                    <div className="modal-servicios__buttonsBox">
                        <button className="modal-servicios__imageButtons gtm_solicitar_servicios_personas_modulo"
                            onClick={() => navigate(redireccionBoton)}>
                            <img className="gtm_solicitar_servicios_personas_modulo" 
                                src={imagenesEmpleo[0].file.url}
                                alt={"Icono personas"}
                            />
                            <div className="modal-servicios__textButtons gtm_solicitar_servicios_personas_modulo">
                                {rawToReact(descripcion.raw, contentfulRenderOptions)}
                            </div>
                        </button>

                        {pathName.split('/')[3] === 'solicitud-servicios' ?
                            (
                                <button className="modal-servicios__imageButtons gtm_solicitar_servicios_empresas_modulo"
                                    onClick={rest.onClose}>
                                    <img className="gtm_solicitar_servicios_empresas_modulo" 
                                        src={imagenesEmpleo[1].file.url}
                                        alt={"Icono empresas"}
                                    />
                                    <div className="modal-servicios__textButtons gtm_solicitar_servicios_empresas_modulo">
                                        {rawToReact(descripcionFormulario.raw, contentfulRenderOptions)}
                                    </div>                        
                                </button>
                            ):
                            (
                                <button className="modal-servicios__imageButtons gtm_solicitar_servicios_empresas_modulo"
                                    onClick={() =>
                                        {
                                            navigate(redireccionBotonOpcional);
                                            localStorage.setItem('solicitarServicios', 'true');
                                        }
                                    }>
                                    <img className="gtm_solicitar_servicios_empresas_modulo"
                                        src={imagenesEmpleo[1].file.url}
                                        alt={"Icono empresas"}
                                    />
                                    <div className="modal-servicios__textButtons gtm_solicitar_servicios_empresas_modulo">
                                        {rawToReact(descripcionFormulario.raw, contentfulRenderOptions)}
                                    </div>                        
                                </button>
                            )
                        }
                    </div>
                </div>
            </div>
        </div> 
    );
};

export default ModalSolicitudServicios;